import { render } from "./contactUs.vue?vue&type=template&id=eab5543e&scoped=true"
import script from "./contactUs.vue?vue&type=script&lang=js"
export * from "./contactUs.vue?vue&type=script&lang=js"

import "./contactUs.vue?vue&type=style&index=0&id=eab5543e&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eab5543e"]])

export default __exports__